<template>
	<div
		id="blog-sidebar"
		class="w-full pb-4 lg:w-1/3 lg:mt-4 lg:pt-4"
	>
		<div class="sticky grid w-full grid-cols-1 justify-content-center top-16">
			<Ad
				v-if="zones[10]"
				:zone="10"
				:content="zones[10]"
			/>

			<NewsletterForm
				class="w-full max-w-sm px-8 mx-auto my-4"
			/>

			<Ad
				v-if="zones[10]"
				:zone="10"
				:content="zones[10]"
			/>
		</div>
	</div>
</template>

<script>
import Ad from '@/components/multiUse/Ad.vue'
export default {
	components: {
		NewsletterForm: () => import('@/components/multiUse/NewsletterForm'),
		Ad
	},
	computed: {
		zones: function () {
			return this.$store.state.zones
		}
	}
}
</script>
